import * as Yup from 'yup';

// import { DictOpponent } from '@models';

export function useValidationSchema() {
  return Yup.object().shape({
    // concernedAuthority: Yup.mixed<DictOpponent>().nullable().required(),
  });
}
